import React, { Component } from 'react';
import CardProduct from './CardProduct';
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import EventEmitter from '../event';


const styles = theme => ({ });

class GridProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: this.props.rows,
      lang: this.props.lang,
      logged: this.props.logged,
      express: this.props.express,
      tariff: this.props.tariff,
      price_sort: this.props.price_sort,
      dimensions: null,
      isFlag: true,
      client_country_id: this.props.client_country_id,
      cart_products: this.props.cart_products,
      fav_products: this.props.fav_products,
      jwt: this.props.jwt,
      api_url: this.props.api_url,
      stocks: this.props.stocks,
      customFilterManufacturerIds: this.props.customFilterManufacturerIds,
      customFilterManufacturer: this.props.customFilterManufacturer
    };
  }

  componentDidMount() {
    this.setState({
      dimensions: {
        width: this.container.clientWidth,
        height: this.container.clientHeight,
      },
    });
  }

  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy);
  }

  stableSort(array, sorting, sorting_field) {
    if (sorting != "no_filter") {
      const comparator = this.getComparator(sorting, sorting_field)
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
    }
    else {
      return array;
    }

  }

  componentDidUpdate(prevProps) {
    if (this.props.rows !== prevProps.rows) {
      this.setState({
        rows: this.props.rows
      });
    }
    if (this.props.stocks !== prevProps.stocks) {
      this.setState({
        stocks: this.props.stocks
      });
    }
    if (this.state.isFlag) {
      this.setState({
        isFlag: false,
        dimensions: {
          width: this.container.clientWidth,
          height: this.container.clientHeight,
        },
      });
      EventEmitter.disptach('heightMainSection', this.container.clientHeight)
    }
  }

  renderContent() {
    const { 
      rows, 
      lang, 
      logged, 
      express, 
      tariff, 
      price_sort, 
      dimensions, 
      client_country_id,
      cart_products,
      fav_products,
      jwt,
      api_url,
      stocks,
      customFilterManufacturerIds,
      customFilterManufacturer
    } = this.state;

    const { classes } = this.props;
    

    let sorting_field = "pvp";
    if (express) {
      sorting_field = "net";
    }

    return (

      <Grid container className="grid-row">
      {this.stableSort(rows, price_sort, sorting_field)
        .map((rowData, index) => {
        let manufacturerId = null;
        try {
          manufacturerId = JSON.parse(rowData.product_data.raw).manufacturer_id;
        } catch (e) {
          manufacturerId = null;
        }
        // show only if manufacturerId is NOT included in customFilterManufacturerIds
        if (customFilterManufacturerIds && customFilterManufacturerIds.includes(manufacturerId)) {
          return null;
        }

        return (
          <Grid key={"gridProduct" + index} item md={3} className="grid-col">
          <CardProduct 
            data={rowData} 
            lang={lang} 
            logged={logged} 
            express={express} 
            tariff={tariff} 
            client_country_id={client_country_id} 
            cart_products={cart_products} 
            fav_products={fav_products} 
            jwt={jwt}
            sa={false}
            api_url={api_url}
            stocks={stocks}  
            customFilterManufacturer={customFilterManufacturer}
            customFilterManufacturerIds={customFilterManufacturerIds}              
          />
          </Grid>
        );
        })
      }
      </Grid>

    );
  }

  render() {
    const { rows, dimensions, stocks } = this.state;

    return (
      rows.length > 0 &&
      <div ref={el => (this.container = el)}>
        {dimensions && this.renderContent()}
      </div>
    );
  }
}

export default withStyles(styles)(GridProducts);